import script from "./CustomDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomDropdown.vue?vue&type=script&setup=true&lang=js"

import "./CustomDropdown.vue?vue&type=style&index=0&id=48f7f0c3&scoped=true&lang=css"

import exportComponent from "/builds/sense/sense-signer/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48f7f0c3"]])

export default __exports__